import {
    FiCompass,
    FiPenTool,
    FiCodepen,
    FiLinkedin,
    FiShoppingBag,
    FiTwitter,
    FiInstagram,
    FiGithub,
} from 'react-icons/fi';

export const links = [
    {
        icon: <FiCompass style={{ marginRight: '1rem' }} />,
        label: '',
        title: 'My Personal Site',
        secondary: false,
        url: '/',
    },
    {
        icon: <FiPenTool style={{ marginRight: '1rem' }} />,
        label: '',
        title: 'Logo Design Portfolio',
        secondary: true,
        url: 'https://instagram.com/acreativeid',
    },
    {
        icon: <FiCodepen style={{ marginRight: '1rem' }} />,
        label: 'Useful code examples for your website:',
        title: 'Responsive Navbar',
        secondary: true,
        url: 'https://codepen.io/alfanme/pen/zYoqyXQ',
    },
    {
        icon: <FiShoppingBag style={{ marginRight: '1rem' }} />,
        label: 'Check out my shoe brand official store:',
        title: 'CASOOT Official Store',
        secondary: true,
        url: 'https://instagram.com/casootshoes',
    },
    {
        icon: <FiLinkedin style={{ marginRight: '1rem' }} />,
        label: `Let's connect on social media:`,
        title: 'Connect on Linkedin',
        secondary: true,
        url: 'https://linkedin.com/in/ahmad-alfan-820618140/',
    },
    {
        icon: <FiInstagram style={{ marginRight: '1rem' }} />,
        label: '',
        title: 'Follow me on Instagram',
        secondary: true,
        url: 'https://instagram.com/alfanme',
    },
    {
        icon: <FiTwitter style={{ marginRight: '1rem' }} />,
        label: '',
        title: 'Follow me on Twitter',
        secondary: true,
        url: 'https://twitter.com/ahmdalfan',
    },
    {
        icon: <FiGithub style={{ marginRight: '1rem' }} />,
        label: '',
        title: 'Follow me on Github',
        secondary: true,
        url: 'https://github.com/alfanme',
    },
];
